<template>
  <div class="help">
    <div class="page-header">
      <h1>{{ $t('help.help') }}</h1>
    </div>
    <div class="help-item">
      <h3>{{ $t('help.docs') }}</h3>
      <p>{{ $t('help.docsDesc') }}</p>
      <a rel="noopener" target="_blank" :href="docsLink">{{ $t('help.forwardView') }}</a>
    </div>
    <Divider />
    <div class="help-item">
      <h3>{{ $t('help.about') }}</h3>
      <p>{{ $t('help.kuiperDesc') }}</p>
      <a rel="noopener" target="_blank" href="https://github.com/lf-edge/ekuiper">Github</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Help',

  data() {
    return {}
  },

  computed: {
    docsLink() {
      const { lang } = this.$store.state
      if (lang !== 'zh') {
        return 'https://docs.emqx.io/en/kuiper/latest/'
      }
      return 'https://docs.emqx.cn/cn/kuiper/latest/'
    },
  },

  methods: {},
}
</script>

<style lang="scss">
.help {
  width: 80%;
  .help-item {
    h3 {
      font-size: 16px;
      margin-bottom: 20px;
    }
    p {
      color: #b0b0b0;
      line-height: 1.8;
      margin-bottom: 20px;
    }
    a {
      margin-right: 16px;
    }
  }
}
</style>
